import VueRouter from "vue-router"

import Login from '../components/Login.vue'
import LoginMobile from '../components/LoginMobile.vue'
import Home from '../components/Home.vue'
import Welcome from '../components/user/Welcome'
import User from '../components/user/User'
import UserTransaction from '../components/user/UserTransaction'
import UserRegister from '../components/user/UserRegister.vue'
import UserList from '../components/user/UserList.vue'
import Team from '../components/user/Team'
import Percentage from '../components/percentage/Percentage'
import OperateLog from '../components/operatelog/OperateLog'
import OrderInfo from '../components/orderinfo/OrderInfo'
import MyOrderInfo from '../components/orderinfo/MyOrderInfo'
import GroupOrderInfo from '../components/orderinfo/GroupOrderInfo'
import NotSubmitOrderInfo from '../components/orderinfo/NotSubmitOrderInfo'
import OverallOrder from '../components/orderinfo/OverallOrder'
import MobileHome from '../components/mobile/Home.vue'
import MobileUser from '../components/mobile/user/User'
import MobileTeam from '../components/mobile/user/Team'
import MobileRole from '../components/mobile/role/Role'
import MobilePercentage from '../components/mobile/percentage/Percentage'
import MobileOperateLog from '../components/mobile/operatelog/OperateLog'
import MobileOrderInfo from '../components/mobile/orderinfo/OrderInfo'
import MobileMyOrderInfo from '../components/mobile/orderinfo/MyOrderInfo'
import MobileGroupOrderInfo from '../components/mobile/orderinfo/GroupOrderInfo'

import Carrier from '../components/library/Carrier'
import CleavageSite from '../components/library/CleavageSite'
import Region from '../components/other/Region'
import WelcomeSet from '../components/other/WelcomeSet'
import Transaction from '../components/other/Transaction'
import OrderTip from '../components/other/OrderTip'
import SystemSet from '../components/other/SystemSet'
import SeqCompany from '../components/other/SeqCompany'
import HasOveralledOrder from '../components/orderinfo/HasOveralledOrder'

const router =  new VueRouter( {
    mode:'history',
    routes:[
        {
            path:'/',
            component:Login
        },
        {
            path:'/loginMobile',
            component:LoginMobile
        },
        {
            path:'/login',
            component:Login
        },
        {
            path:'/userRegister',
            component:UserRegister
        },
        // {
        //     path:'/mobile/orderInfo',
        //     component:MobileMyOrderInfo
        // },
        {
            path:'/home',
            component:Home,
            children:[
                {
                    path:'welcome',
                    component: Welcome
                },
                {
                    path:'user',
                    component: User
                },
                {
                    path:'userList',
                    component: UserList
                },
                {
                    path:'userTransaction',
                    component: UserTransaction
                },
                {
                    path:'team',
                    component: Team
                },
                {
                    path:'carrier',
                    component: Carrier
                },
                {
                    path:'percentage',
                    component: Percentage
                },
                {
                    path:'operateLog',
                    component: OperateLog
                },
                {
                    path:'orderInfo',
                    component: OrderInfo
                },
                {
                    path:'myOrderInfo',
                    component: MyOrderInfo
                },
                {
                    path:'notSubmitOrderInfo',
                    component: NotSubmitOrderInfo
                },
                {
                    path:'groupOrderInfo',
                    component: GroupOrderInfo
                },
                {
                    path:'overallOrder',
                    component: OverallOrder
                },
                {
                    path:'cleavageSite',
                    component: CleavageSite
                },
                {
                    path:'region',
                    component: Region
                },
                {
                    path:'welcomeSet',
                    component: WelcomeSet
                },
                {
                    path:'transaction',
                    component: Transaction
                },
                {
                    path:'orderTip',
                    component: OrderTip
                },
                {
                    path:'systemSet',
                    component: SystemSet
                },
                {
                    path:'seqCompany',
                    component: SeqCompany
                },
                {
                    path:'hasOveralledOrder',
                    component: HasOveralledOrder
                }
            ]
        },
        {
            path:'/mobile',
            component:MobileHome,
            children:[
                {
                    path:'user',
                    component: MobileUser
                },
                {
                    path:'team',
                    component: MobileTeam
                },
                {
                    path:'role',
                    component: MobileRole
                },
                {
                    path:'percentage',
                    component: MobilePercentage
                },
                {
                    path:'operateLog',
                    component: MobileOperateLog
                },
                {
                    path:'orderInfo',
                    component: MobileOrderInfo
                },
                {
                    path:'myOrderInfo',
                    component: MobileMyOrderInfo
                },
                {
                    path:'groupOrderInfo',
                    component: MobileGroupOrderInfo
                }
            ]
        }
    ]
});

function isPhone(){
    let flag = false;
    flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
    // let flag = navigator.userAgent.match(/(phone|pod|iPhone|iPod|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
    return flag;
 }

function hasAuthority(path) {
    let flag = false;
    const adminAuthority = "/home/welcome, /home/user, /home/userList, /home/userTransaction, /home/team, /home/carrier, /home/percentage,"
    +" /home/operateLog, /home/orderInfo, /home/overallOrder, /home/cleavageSite, /home/region, /home/welcomeSet, /home/transaction, /home/orderTip,"
    +" /home/systemSet, /home/seqCompany, /home/hasOveralledOrder,/mobile/orderInfo";
    const agentAuthority = "/home/groupOrderInfo, /home/transaction,/mobile/groupOrderInfo";
    const responsibleAuthority = "/home/myOrderInfo, /home/notSubmitOrderInfo, /home/groupOrderInfo, /home/transaction,/mobile/groupOrderInfo,/mobile/myOrderInfo";
    const normalAuthority = "/home/myOrderInfo, /home/notSubmitOrderInfo, /home/transaction,/mobile/myOrderInfo";
    let user = JSON.parse(window.localStorage.getItem("user"));
    if(user.roleCode === 'SUPER' || user.roleCode === 'ADMIN') {
        if(adminAuthority.indexOf(path) >= 0) {
            flag = true;
        }
    } else if(user.roleCode === 'AGENT'){
        if(agentAuthority.indexOf(path) >= 0) {
            flag = true;
        }
    } else if(user.roleCode === 'RESPONSIBLE'){
        if(responsibleAuthority.indexOf(path) >= 0) {
            flag = true;
        }
    } else {
        if(normalAuthority.indexOf(path) >= 0) {
            flag = true;
        }
    }
    return flag;
}

//导航守卫
router.beforeEach((to,from,next)=>{
    const tokenStr = window.localStorage.getItem("user");
    if(isPhone()) {
        // if(to.path === "/") return next("/loginMobile");
        // if(to.path === "/login") return next("/loginMobile");
        // if(to.path === "/loginMobile") return next();
        // if(to.path === "/userRegister") return next();
        // console.log("phone");
        // console.log(to.path);
        if(to.path === "/") {
            if(tokenStr) {
                return next("home");
            }else {
                return next("/loginMobile");
            }
        }else if(to.path === "/loginMobile") {
            if(tokenStr) {
                return next("home");
            }else {
                return next();
            }
        } else if(to.path === "/login") {
            return next("/loginMobile");
        }else if(!hasAuthority(to.path)) {
            // console.log("bb");
            let user = JSON.parse(tokenStr);
            if(user.roleCode === 'SUPER') {
                return next("/mobile/orderInfo");
            } else if(user.roleCode === 'ADMIN') {
                return next("/mobile/orderInfo");
            } else if (user.roleCode === 'AGENT') {
                return next("/mobile/groupOrderInfo");
            } else if(user.roleCode === 'RESPONSIBLE') {
                return next("/mobile/groupOrderInfo");
            } else {
                return next("/mobile/myOrderInfo");
            }
        } else{
            
            let user = JSON.parse(tokenStr);
            // console.log(user.roleCode);
            let pathStr = to.path;
            let cc = pathStr.includes("home/");
            // console.log(cc);
            if(cc){
                if(user.roleCode === 'SUPER') {
                    return next("/mobile/orderInfo");
                } else if(user.roleCode === 'ADMIN') {
                    return next("/mobile/orderInfo");
                } else if (user.roleCode === 'AGENT') {
                    return next("/mobile/groupOrderInfo");
                } else if(user.roleCode === 'RESPONSIBLE') {
                    return next("/mobile/groupOrderInfo");
                } else {
                    return next("/mobile/myOrderInfo");
                }
            }
            
        }
        
        //return next("/mobile/myOrderInfo");
    }else {
        // console.log("home");
        // console.log(to.path);
        if(to.path === "/") {
            if(tokenStr) {
                return next("home");
            }else {
                return next("/login");
            }
        }else if(to.path === "/login") {
            if(tokenStr) {
                return next("home");
            }else {
                return next();
            }
        } else if(to.path === "/userRegister") {
            return next();
        } else if(to.path === "/loginMobile") {
            return next("/login");
        }else if(!hasAuthority(to.path)) {
            // console.log("aa");
            let user = JSON.parse(tokenStr);
            if(user.roleCode === 'SUPER') {
                return next("/home/orderInfo");
            } else if(user.roleCode === 'ADMIN') {
                return next("/home/orderInfo");
            } else if (user.roleCode === 'AGENT') {
                return next("/home/groupOrderInfo");
            } else if(user.roleCode === 'RESPONSIBLE') {
                return next("/home/myOrderInfo");
            } else {
                return next("/home/myOrderInfo");
            }
        }else {
            let pathStr = to.path;
            let cc = pathStr.includes("mobile/");
            // console.log(cc);
            let user = JSON.parse(tokenStr);
            if(cc){
                if(user.roleCode === 'SUPER') {
                    return next("/home/orderInfo");
                } else if(user.roleCode === 'ADMIN') {
                    return next("/home/orderInfo");
                } else if (user.roleCode === 'AGENT') {
                    return next("/home/groupOrderInfo");
                } else if(user.roleCode === 'RESPONSIBLE') {
                    return next("/home/myOrderInfo");
                } else {
                    return next("/home/myOrderInfo");
                }
            }
        }
    }

     if(!tokenStr) {
        if(isPhone()) {
            return next("/loginMobile");
        }else {
            return next("/login");
        }
     }
         
    next();
})

export default router;
